import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'components/rich-text';
import Button from 'components/button';
import Link from 'components/link';


import Heading from 'components/heading';


const ButtonInfoBlock = ({   onPageEditing, title, text, buttonText, buttonTarget, useChatbot }) => {
  return (
    <div className="button-info-block">
      {title && (
        <div className="button-info-block--header">
          <Heading
            className="button-info-block--header-title"
            onPageEditing={onPageEditing.title}
          >
            {title}
          </Heading>
        </div>
      )}
      
      {text && <RichText className="button-info-block--text" {...text} />}
      {useChatbot ? (
        <div className="chatbot-button-container chatbot-button-dark" />
      ) : (

      <Link
        className="info-block--cta-button"
        theme={[
          Button.themes.primary,
          Button.themes.large,
          Button.themes.dark
        ]}
        useButtonStyles={true}
        url={buttonTarget}
        openInNewWindow={true}
        >
          {buttonText}
      </Link>


      )}
    </div>
  );
};

ButtonInfoBlock.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.exact(RichText.propTypes),
  buttonText: PropTypes.string.isRequired,
  buttonTarget: PropTypes.string,
  useChatbot: PropTypes.bool.isRequired,
};

ButtonInfoBlock.defaultProps = {
  onPageEditing: {}
};

export default ButtonInfoBlock;
